document.addEventListener('DOMContentLoaded', function() {

    iconListPopups();

    if(! document.querySelector('.template-collection')) return;

    const productCards = document.querySelectorAll('.product-card');

    productCards.forEach(productCard => {
        productCard.addEventListener('mouseenter', function(e) {
            entered = true;
            slideProductImages(e.target);
        });
    });
});

let entered = false;

function slideProductImages(productCard) {

    if(! productCard) return;

    const slider = productCard.querySelector('.product-card--image');
    if(! slider) return;


    // get all figures in the product card
    // get the width of the first image
    // scroll the slider by that width every 2 seconds
    // when it reaches the end, scroll back to the start
    const figures = productCard.querySelectorAll('figure');
    let numFigures = figures.length;
    if(numFigures < 2) return;

    const img1 = figures[0].querySelector('img');

    if(! img1) return;

    const imageWidth = img1.clientWidth;

    slider.scrollBy({
        left: imageWidth,
        behavior: 'smooth'
    });

    let imageCounter = 2; // we've already shown the first image

    const imageSwapTimer = setInterval(() => {
    
        if(! entered) {
            clearInterval(imageSwapTimer);
            return; 
        }

        if(imageCounter <= numFigures-1) {
            slider.scrollBy({
                left: imageWidth,
                behavior: 'smooth'
            });
            imageCounter++;
        } else {
            slider.scrollTo({
                left: 0,
                behavior: 'smooth'
            });
            imageCounter = 1;
        }
    }, 2000);

    productCard.addEventListener('mouseleave', function() {
        clearInterval(imageSwapTimer);
        slider.scrollTo({
            left: 0,
            behavior: 'smooth'
        });
            entered = false;
    });
}

function iconListPopups() {
    const iconListItems = document.querySelectorAll('.product--icon-list li');

    if (!iconListItems.length) return;

    const popupContent = {
        returns: {
            title: 'Easy Returns',
            body: `<p>

Full-priced items (excluding cut fabric) are eligible for a refund, exchange, or credit. Items must be returned within 14 days of receiving your order. After 14 days, store credit only.
</p>
<p>Sale items are eligible for an exchange or credit, except items marked Final Sale. Returns must be notified within 5 days of receiving your order.
</p>
<p>Cut fabric cannot be returned or exchanged, so please choose carefully.
</p>
<p>All returned items must be unworn, unwashed, and have tags attached.
</p>

<h3 style="font-size: 1.3rem">Exchanges (Australia)</h3>
<p>
You cover the cost of return shipping. We'll ship the new item back to you for free.
</p>

<h3 style="font-size: 1.3rem">Credit notes</h3>
<p>

Valid for one year from date of issue.
</p>

<h3 style="font-size: 1.3rem">How to return or exchange</h3>
<p>
If you have an account, log in and go to Returns. Otherwise, email hello@surfaceart.com.au or call (02) 9659 9176.
</p>
`
        },
        free: {
            title: 'Free Shipping',
            body: `<p>
We ship via Australia Post.
</p>

<ul>
    <li>Orders over AUD$150: free standard delivery, or $15 for Express Post</li>
    <li>Orders AUD$150 and under: $10 flat rate</li>
</ul>
`
        },
        quick: {
            title: 'Quick Shipping',
            body: `<p>
Generally orders received by lunchtime Monday to Thursday will be shipped on the same day otherwise will be shipped the next business day. You will receive a shipping notification once your order has left my studio. The estimated delivery time within Australia is 2-6 working days.
</p>`
        }
    };

    const closeSVG = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 1L1 13M13 13L1 1" stroke="var(--color-body)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

    const modalId = 'IconListPopupModal';

    if (!document.getElementById(modalId)) {
        document.body.insertAdjacentHTML('beforeend', `
            <modal-dialog id="${modalId}" class="product-popup-modal sizeguide-modal" data-section-id="icon-list-popup">
              <div role="dialog" aria-modal="true" class="product-popup-modal__content" tabindex="-1">
                <div class="product-popup-modal__content-header">
                  <h2 style="font-size: 1.5rem" id="${modalId}-title"></h2>
                  <button id="ModalClose-${modalId}" type="button" class="product-popup-modal__toggle" aria-label="Close">${closeSVG}</button>
                </div>
                <div class="product-popup-modal__content-info" id="${modalId}-body"></div>
              </div>
            </modal-dialog>`);
    }

    const modal = document.getElementById(modalId);
    const modalTitle = document.getElementById(`${modalId}-title`);
    const modalBody = document.getElementById(`${modalId}-body`);

    iconListItems.forEach(item => {
        item.addEventListener('click', function () {
            const text = item.textContent.trim();
            let content = null;

            if (text.match(/returns/i)) {
                content = popupContent.returns;
            } else if (text.match(/free/i)) {
                content = popupContent.free;
            } else if (text.match(/quick/i)) {
                content = popupContent.quick;
            }

            if (!content) return;

            modalTitle.textContent = content.title;
            modalBody.innerHTML = content.body;
            modal.show(item);
        });
    });
}
